import React from "react";
import { useSelector } from "react-redux";

import { CatalogueGridWrapper } from "./catalogue.styles";
import ItemCard from "./ItemCard";
import EmptyState from "../../../../common/components/EmptyState";
import { EmptySearcedIcon } from "../../../../common/assets/icons/catalogueIcons";
import { EmptyItemIcon } from "../../../../../AuthenticatedApp/components/productCatalogue/common/images/Icons";

const CatalogueItems = ({ searchedItems, handleCreateOrder }) => {
    const { catalogueItems } = useSelector((state) => state.catalogueState);

    if (catalogueItems?.length < 1) {
        return (
            <EmptyState
                emptyIcon={<EmptyItemIcon />}
                title="No Items"
                details="There are no items in your inventory. To add items, reach out to your admin"
            />
        );
    }
    return (
        <>
            {searchedItems?.length > 0 ? (
                <CatalogueGridWrapper className="animated kudaFadeInUp">
                    {searchedItems?.map((item) => (
                        <ItemCard
                            item={item}
                            key={`sales-items-${item.name}`}
                            handleCreateOrder={handleCreateOrder}
                        />
                    ))}
                </CatalogueGridWrapper>
            ) : (
                <EmptyState
                    emptyIcon={<EmptySearcedIcon />}
                    title="Couldn’t Find Item"
                    details="We couldn’t find the item you searched for. Kindly check the name and try again."
                />
            )}
        </>
    );
};

export default CatalogueItems;
